import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import WeddingInquiryDialog from "@/components/WeddingInquiryDialog";

// Full-width cinematic banner — signature "Mock Wedding in India in 1 Day" experience.
export default function MockWeddingBanner() {
  const [open, setOpen] = useState(false);
  return (
    <section
      className="relative min-h-[70vh] md:min-h-[80vh] flex items-center overflow-hidden"
      data-testid="mock-wedding-banner"
    >
      <img
        src="https://images.pexels.com/photos/38922738/pexels-photo-38922738.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920"
        alt="Symbolic Indian wedding — mock wedding experience in India"
        className="absolute inset-0 w-full h-full object-cover animate-slow-zoom"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/45 to-transparent" />
      <div className="relative z-10 container-tti py-16 md:py-24">
        <div className="max-w-2xl">
          {/* Signature badge */}
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-marigold/95 text-foreground text-[10px] font-semibold uppercase tracking-[0.25em] mb-6">
            <Sparkles className="w-3.5 h-3.5" />
            Signature Experience · New
          </div>

          <h2
            className="font-serif text-4xl md:text-6xl lg:text-7xl text-white leading-[1.02] tracking-tight animate-fade-up"
            data-testid="mock-wedding-heading"
          >
            Mock Wedding
            <br />
            <span className="italic text-marigold">in India — in 1 day.</span>
          </h2>

          <p
            className="mt-6 text-white/85 text-lg md:text-xl font-light leading-relaxed max-w-xl animate-fade-up"
            style={{ animationDelay: "0.15s" }}
          >
            Celebrate your love with a full symbolic Indian wedding ceremony —{" "}
            <em>mehendi, baraat, phera, sindoor and sangeet</em> — all in one unforgettable day. Non-legally-binding, entirely magical.
          </p>

          {/* Highlights row */}
          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-[13px] text-white/85">
            {[
              "Traditional attire & mehendi",
              "Pandit-led phera ceremony",
              "Baraat with dhol band",
              "Photography included",
            ].map((h) => (
              <div key={h} className="inline-flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-marigold" />
                <span>{h}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/themes/mock-wedding"
              data-testid="mock-wedding-cta"
              className="inline-flex items-center gap-2 px-8 py-4 bg-marigold text-foreground text-sm uppercase tracking-wider font-medium hover:bg-white transition-colors"
            >
              Plan your ceremony <ArrowRight className="w-4 h-4" />
            </Link>
            <button
              type="button"
              onClick={() => setOpen(true)}
              data-testid="mock-wedding-inquire"
              className="inline-flex items-center gap-2 px-8 py-4 border border-white/40 text-white text-sm uppercase tracking-wider hover:bg-white/10 transition-colors"
            >
              Ask a curator
            </button>
          </div>
        </div>
      </div>
      <WeddingInquiryDialog open={open} onOpenChange={setOpen} defaultType="mock-wedding" />
    </section>
  );
}
